/**
 * API calls for the import wizard.
 * Follows the same conventions as endpoints.ts (uses the `api` client helper).
 */

import { api } from "./client";
import type { ImportConfig, MergeRange } from "@/lib/mapper/types";

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

export type PreviewSheet = {
  name: string;
  rawGrid: unknown[][];
  merges: MergeRange[];
  suggestedConfig: ImportConfig;
  confidence: number;
};

export type PreviewResult = {
  sheets: PreviewSheet[];
};

// ---------------------------------------------------------------------------
// parsePreview
// ---------------------------------------------------------------------------

/**
 * POST /api/workbooks/parse-preview
 *
 * Uploads a file (multipart, field "file") and returns per-sheet raw grids +
 * a suggested ImportConfig + confidence for each sheet. No persistence; the
 * file must be re-sent on commit.
 */
export async function parsePreview(file: File): Promise<PreviewResult> {
  const formData = new FormData();
  formData.append("file", file);
  return api.post<PreviewResult>("/api/workbooks/parse-preview", formData);
}
